/**
 * File: apps/qbench-cp/reactapp/src/index.js
 *
 * Purpose: Application entry point — mounts the React tree onto the DOM root.
 *
 * Scope: Top-level app bootstrap: router, public routes, protected app shell, and theme
 *     seeding.
 *
 * Tags: customer-portal
 *
 * Overview: Seeds the "default-theme" localStorage entry from the static theme module
 *     before first render, then renders a `Root` component wrapping the app in
 *     `React.StrictMode`, a `BrowserRouter`, and `AppShell`. Public routes (from
 *     `App/routes`) are registered directly on the router; any other path renders
 *     `ProtectedRoutes`, which wraps the main `App` component in `AppProvider`. Calls
 *     `reportWebVitals()` after the initial render.
 */

import AppShell from 'App/AppShell';
import { publicRoutes } from 'App/routes';
import { AppProvider } from 'App/store';
import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { setLocalStorage } from 'shared/theme/storage';
import * as theme from 'shared/theme/theme';
import App from './App';
import './fonts.css';
import './index.css';
import reportWebVitals from './reportWebVitals';

setLocalStorage('default-theme', theme);

function ProtectedRoutes() {
  return (
    <AppProvider>
      <App />
    </AppProvider>
  );
}

function Root() {
  return (
    <React.StrictMode>
      <BrowserRouter>
        <AppShell>
          <Routes>
            {publicRoutes.map((props) => (
              <Route key={props.path} {...props} />
            ))}
            <Route path="/*" element={<ProtectedRoutes />} />
          </Routes>
        </AppShell>
      </BrowserRouter>
    </React.StrictMode>
  );
}

ReactDOM.render(<Root />, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
